var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionIcon = function SvgQuestionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48 10.837c.098 0 .178-.08.178-.178v-.91a.18.18 0 0 0-.178-.177h-.97a.18.18 0 0 0-.177.178v.909c0 .098.08.178.177.178zm.193-2.377v-.469a2.34 2.34 0 0 0 1.664-2.25 2.34 2.34 0 0 0-4.677-.177.17.17 0 0 0 .171.178h.985c.098 0 .176-.08.193-.177a1 1 0 0 1 .986-.825 1 1 0 0 1 1.002 1.002 1 1 0 0 1-1.002 1.001H6.51a.18.18 0 0 0-.177.178v1.717h1.162c.098 0 .178-.08.178-.177"
  })));
};
export default SvgQuestionIcon;